import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import axios from "axios";
import { useLocation } from "react-router-dom";

import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import GenrateBills from "./componets/GenrateBills";
import GenrateNotification from "./componets/GenralNotification";
import LoadingScreen from "../../components/Loder/LoadingScreen";
import { getTrans as t } from "../../Localization/translations";
import Helper from "../../Helper";
import GenrateIncomeRecognition from "./componets/GenrateIncomeRecogition";
import GenerateAgingBucket from "./componets/GenerateAgingBucket";
import ScheduleProcess from "./componets/scheduleProcess";


function ViewProcessing() {
  const GenrateBilltableRef = React.useRef();
  const GenrateNotificationtableRef = React.useRef();
  const location =  useLocation()
  let state =  location.state
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [flag, setFlag] = useState("");
  const [flagNotification, setFlagNotification] = useState("");
  const [selectedValue3, setSelectedValue3] = useState("");
  const [Billing, setGenrateBills] = useState(false);
  const [genratenotification, setGenrateNotification] = useState(false);
  const [incomerecognition, setIncomeRecognition] = useState(false);
  const [agingbucket, setAgingBucket] = useState(false);
  const [moniter, setMoniter] = useState("Billing");
  const [selectedValue, setSelectedValue] = useState(null);
  const [billtroughdate, setBillTroughDate] = useState(new Date());


  //Schedule
  const [scheduleType, setScheduleType] = useState('instant');
  const [startDate, setStartDate] = useState('');
  const [startTime, setStartTime] = useState('00:00');
  const [endDate, setEndDate] = useState('');
  const [endTime, setEndTime] = useState('');
  const [rerunInterval, setRerunInterval] = useState('1');
  const [rerunUnit, setRerunUnit] = useState('');

  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [frequency, setFrequency] = useState("");
  const [selectedWeekdays, setSelectedWeekdays] = useState([]);
  const [incrementParams, setIncrementParams] = useState(false);
  const [recalculateParams, setRecalculateParams] = useState(false);
  const [schedule, setSchedule] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const buttonElement = document.querySelectorAll(".tablinks");
  const tabContent = document.querySelectorAll(".tabcontent");
  const [showScheduler, setShowScheduler] = useState(false);
  const [contract_number, setContract_number] = useState('')

  buttonElement.forEach(function (i) {
    i.addEventListener("click", function (event) {
      for (let x = 0; x < buttonElement.length; x++) {
        if (event.target.id === buttonElement[x].id) {
          buttonElement[x].className = buttonElement[x].className.replace(
            " active",
            ""
          );
          tabContent[x].style.display = "block";
          event.currentTarget.className += " active";
        } else {
          tabContent[x].style.display = "none";
          buttonElement[x].className = buttonElement[x].className.replace(
            " active",
            ""
          );
        }
      }
    });
  });


  useEffect(() => {
    moniter === "Billing"
      ? setGenrateBills(true) && setGenrateBills("Billing")
      : setGenrateBills(false);
    moniter === "Notification"
      ? setGenrateNotification(true) && setGenrateBills("Notification")
      : setGenrateNotification(false);
    moniter === "Income Recognition"
      ? setIncomeRecognition(true) && setGenrateBills("Income Recognition")
      : setIncomeRecognition(false);
    moniter === "Bucket"
      ? setAgingBucket(true) && setGenrateBills("Bucket")
      : setAgingBucket(false);
    setLoading(false, 6000);
  }, [moniter]);

  // const handleOpenScheduler = () => {
  //   setShowScheduler(true); // Open the Scheduler modal
  // };

  const loadOptionsbilling = async () => {
    if (moniter === "Billing") {
      const responseJSON = await axios.get(
        API +
        `helper/search/processing/?request_date=${Helper.DatePicker(
          selectedValue3
        )}&process_name=Billing`,
        { headers: authHeader() }
      );
      return setItems(responseJSON.data);
    } else if (moniter === "Notification") {
      const responseJSON = await axios.get(
        API +
        `helper/search/processing/?request_date=${Helper.DatePicker(
          selectedValue3
        )}&process_name=Notification`,
        { headers: authHeader() }
      );
      return setItems(responseJSON.data);
    }
    else if (moniter === "Income Recognition") {
      const responseJSON = await axios.get(
        API +
        `helper/search/processing/?request_date=${Helper.DatePicker(
          selectedValue3
        )}&process_name=Income Recognition`,
        { headers: authHeader() }
      );
      return setItems(responseJSON.data);
    }
    else if (moniter === "Bucket") {
      const responseJSON = await axios.get(
        API +
        `helper/search/processing/?request_date=${Helper.DatePicker(
          selectedValue3
        )}&process_name=Bucket`,
        { headers: authHeader() }
      );
      return setItems(responseJSON.data);
    }
  };

  const handelChangebilling = (value) => {
    setSelectedValue3(value);
  };

  // const handleOnchage = (e) => {
  //   setMoniter(e.target.value);
  // };

useEffect(() => {
 if(state !== ''){
  setSelectedValue(state)
 }
}, [state])

  return (
    <>
      {loading === false ? (
        <div>
          {/* <ToastContainer /> */}
          {/* <div className="content container-fluid"> */}
            {/* <div className="row"> */}
              {/* <div className="col-md-12"> */}
                {/* <div className=""> */}
                  {/* <div className="row">
                    <div className="col-xl-9">
                      <span className="mb-1">
                        <h5>{t("Processing")} </h5>
                      </span>
                    </div>
                  </div> */}
                  {/* <SlidingPane
                    className="some-custom-class"
                    overlayClassName="some-custom-overlay-class"
                    isOpen={state1.isPaneOpen}
                    title="Filter By"
                    subtitle=""
                    onRequestClose={() => {
                      setState({ isPaneOpen: false });
                    }}
                  >
                    <div className="col-md-12">
                      <div className="">
                        <div className="">
                          <div className="col-lg-12 mb-3">
                            <label className="col-lg-5 col-form-label">
                              {t("Request Date")}
                            </label>
                            <DatePicker
                              className="form-control datepick"
                              selected={selectedValue3}
                              onChange={(e) => handelChangebilling(e)}
                              placeholderText={"dd/mm/yyyy"}
                              showYearDropdown // year show and scrolldown alos
                              scrollableYearDropdown
                              showMonthDropdown
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <button
                          type="button"
                          className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                        >
                          {t("Reset")}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={loadOptionsbilling}
                          className="partyFilter add btn btn-primary ms-auto mb-0"
                        >
                          {t("Apply")}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                    </div>
                  </SlidingPane>

                  <br /> */}
                  {/* <div className="col-lg-2"> */}
                    {/* <div value={moniter}>
                      <span className="mb-0 col-form-label">
                        {t("Select Processing")}
                      </span>
                      <select value={moniter} className="form-control" onChange={handleOnchage}>
                        <option value="Billing" selected>{t("Generate Invoices")}</option>
                        <option value="Notification">{t("Generate Notifications")}</option>
                        <option value="Income Recognition">{t("Income Recognition")}</option>
                        <option value="Bucket">{t("Generate Aging Bucket")}</option>
                      </select>
                    </div>
                    <div className="ms-auto my-auto mt-lg-0 mt-4">
                      <div className="ms-auto my-auto"></div>
                    </div> */}
                  {/* </div> */}
                {/* </div>
              </div>
            </div> */}
          {/* </div> */}
          <ScheduleProcess 
          id={flag}
          setContract_number={setContract_number}
          schedule={schedule}
          setSchedule={setSchedule}
          setShowScheduler={setShowScheduler}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          setBillTroughDate={setBillTroughDate}
          billtroughdate={billtroughdate}
          GenrateBilltableRef={GenrateBilltableRef}
          showScheduler={showScheduler}
          setScheduleType={setScheduleType}
          scheduleType={scheduleType}
          setStartDate={setStartDate}
          startDate={startDate}
          setStartTime={setStartTime}
          startTime={startTime}
          setEndDate={setEndDate}
          endDate={endDate}
          setEndTime={setEndTime}
          endTime={endTime}
          setRerunInterval={setRerunInterval}
          rerunInterval={rerunInterval}
          setRerunUnit={setRerunUnit}
          rerunUnit={rerunUnit}
          setSelectedMonths={setSelectedMonths}
          selectedMonths={selectedMonths}
          setSelectedDates={setSelectedDates}
          selectedDates={selectedDates}
          setFrequency={setFrequency}
          frequency={frequency}
          setSelectedWeekdays={setSelectedWeekdays}
          selectedWeekdays={selectedWeekdays}
          setIncrementParams={setIncrementParams}
          incrementParams={incrementParams}
          setRecalculateParams={setRecalculateParams}
          recalculateParams={recalculateParams}
          setIsLoading={setIsLoading}
          isLoading={isLoading}
          moniter={moniter}
          setMoniter={setMoniter}
          />
          {/* {Billing && <GenrateBills id={flag} setContract_number={setContract_number} schedule={schedule} setSchedule={setSchedule} setShowScheduler={setShowScheduler} setSelectedValue={setSelectedValue} selectedValue={selectedValue} setBillTroughDate={setBillTroughDate} billtroughdate={billtroughdate}
            GenrateBilltableRef={GenrateBilltableRef}
            showScheduler={showScheduler}
            setScheduleType={setScheduleType}
            scheduleType={scheduleType}
            setStartDate={setStartDate}
            startDate={startDate}
            setStartTime={setStartTime}
            startTime={startTime}
            setEndDate={setEndDate}
            endDate={endDate}
            setEndTime={setEndTime}
            endTime={endTime}
            setRerunInterval={setRerunInterval}
            rerunInterval={rerunInterval}
            setRerunUnit={setRerunUnit}
            rerunUnit={rerunUnit}
            setSelectedMonths={setSelectedMonths}
            selectedMonths={selectedMonths}
            setSelectedDates={setSelectedDates}
            selectedDates={selectedDates}
            setFrequency={setFrequency}
            frequency={frequency}
            setSelectedWeekdays={setSelectedWeekdays}
            selectedWeekdays={selectedWeekdays}
            setIncrementParams={setIncrementParams}
            incrementParams={incrementParams}
            setRecalculateParams={setRecalculateParams}
            recalculateParams={recalculateParams}
            moniter={moniter}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setMoniter={setMoniter}
          />}
          {genratenotification && (
            <GenrateNotification id={flagNotification} items={items} setContract_number={setContract_number} GenrateNotificationtableRef={GenrateNotificationtableRef}
              showScheduler={showScheduler}
              setShowScheduler={setShowScheduler}
              setScheduleType={setScheduleType}
              scheduleType={scheduleType}
              setStartDate={setStartDate}
              startDate={startDate}
              setStartTime={setStartTime}
              startTime={startTime}
              setEndDate={setEndDate}
              endDate={endDate}
              setEndTime={setEndTime}
              endTime={endTime}
              setRerunInterval={setRerunInterval}
              rerunInterval={rerunInterval}
              setRerunUnit={setRerunUnit}
              rerunUnit={rerunUnit}
              setSelectedMonths={setSelectedMonths}
              selectedMonths={selectedMonths}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setFrequency={setFrequency}
              frequency={frequency}
              setSelectedWeekdays={setSelectedWeekdays}
              selectedWeekdays={selectedWeekdays}
              setIncrementParams={setIncrementParams}
              incrementParams={incrementParams}
              setRecalculateParams={setRecalculateParams}
              recalculateParams={recalculateParams}
              setSchedule={setSchedule}
              moniter={moniter}
              selectedValue={selectedValue}
              billtroughdate={billtroughdate}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            setMoniter={setMoniter}
            />
          )}
          {incomerecognition && (
            <GenrateIncomeRecognition id={flagNotification} items={items} setContract_number={setContract_number}
              showScheduler={showScheduler}
              setShowScheduler={setShowScheduler}
              setScheduleType={setScheduleType}
              scheduleType={scheduleType}
              setStartDate={setStartDate}
              startDate={startDate}
              setStartTime={setStartTime}
              startTime={startTime}
              setEndDate={setEndDate}
              endDate={endDate}
              setEndTime={setEndTime}
              endTime={endTime}
              setRerunInterval={setRerunInterval}
              rerunInterval={rerunInterval}
              setRerunUnit={setRerunUnit}
              rerunUnit={rerunUnit}
              setSelectedMonths={setSelectedMonths}
              selectedMonths={selectedMonths}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setFrequency={setFrequency}
              frequency={frequency}
              setSelectedWeekdays={setSelectedWeekdays}
              selectedWeekdays={selectedWeekdays}
              setIncrementParams={setIncrementParams}
              incrementParams={incrementParams}
              setRecalculateParams={setRecalculateParams}
              recalculateParams={recalculateParams}
              setSchedule={setSchedule}
              moniter={moniter}
              selectedValue={selectedValue}
              billtroughdate={billtroughdate}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            setMoniter={setMoniter}

            />
          )}
          {agingbucket && (
            <GenerateAgingBucket id={flagNotification} items={items} setContract_number={setContract_number}
              showScheduler={showScheduler}
              setShowScheduler={setShowScheduler}
              setScheduleType={setScheduleType}
              scheduleType={scheduleType}
              setStartDate={setStartDate}
              startDate={startDate}
              setStartTime={setStartTime}
              startTime={startTime}
              setEndDate={setEndDate}
              endDate={endDate}
              setEndTime={setEndTime}
              endTime={endTime}
              setRerunInterval={setRerunInterval}
              rerunInterval={rerunInterval}
              setRerunUnit={setRerunUnit}
              rerunUnit={rerunUnit}
              setSelectedMonths={setSelectedMonths}
              selectedMonths={selectedMonths}
              setSelectedDates={setSelectedDates}
              selectedDates={selectedDates}
              setFrequency={setFrequency}
              frequency={frequency}
              setSelectedWeekdays={setSelectedWeekdays}
              selectedWeekdays={selectedWeekdays}
              setIncrementParams={setIncrementParams}
              incrementParams={incrementParams}
              setRecalculateParams={setRecalculateParams}
              recalculateParams={recalculateParams}
              setSchedule={setSchedule}
              moniter={moniter}
              selectedValue={selectedValue}
              billtroughdate={billtroughdate}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            setMoniter={setMoniter}

            />
          )} */}
        </div>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
}

export default ViewProcessing;
